import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CustomerGroupApi from '../api/customer_group/customer_group.ts';

export const fetchCustomerGroupAsync = createAsyncThunk(
    'customerGroup/fetchCustomerGroup',
    async () => {
        const response = await CustomerGroupApi();
        return response;
    }
);

const customerGroupSlice = createSlice({
    name: 'customerGroup',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCustomerGroupAsync.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchCustomerGroupAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchCustomerGroupAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default customerGroupSlice.reducer;